import { logExtensionEvent } from '@apps/web/lib/datadog_logs';

const MAX_TYPE_LENGTH = 64;
const MAX_DEDUPLICATION_KEYS = 100;
const MAX_ISSUE_ENTRIES = 50;
const ISSUE_EVENT_NAME = 'v3_event_chat.client_issue';
const ISSUE_CAP_EVENT_NAME = 'v3_event_chat.client_issue_cap';

export type EventChatClientIssue = Readonly<{
    readonly profileId: string;
    readonly rendererVersion: string;
    readonly reason:
        | 'unknown_event_type'
        | 'known_payload_invalid'
        | 'orphan_slot'
        | 'protocol_error'
        | 'missing_narration'
        | 'missing_drained_target'
        | 'invalid_organization_timezone';
    readonly lineType: string | null;
    readonly eventType: string | null;
    readonly count: 1;
}>;

const issueKeys = new Set<string>();
let sentIssueEntryCount = 0;

function truncateType(value: string | null): string | null {
    return value === null ? null : value.slice(0, MAX_TYPE_LENGTH);
}

function incrementCapCounter(): void {
    logExtensionEvent(ISSUE_CAP_EVENT_NAME, {});
}

export function recordEventChatClientIssue(issue: EventChatClientIssue): void {
    const lineType = truncateType(issue.lineType);
    const eventType = truncateType(issue.eventType);
    const key = JSON.stringify([
        issue.profileId,
        issue.rendererVersion,
        issue.reason,
        lineType,
        eventType,
    ]);

    if (issueKeys.has(key)) {
        return;
    }
    if (issueKeys.size >= MAX_DEDUPLICATION_KEYS) {
        incrementCapCounter();
        return;
    }
    issueKeys.add(key);

    if (sentIssueEntryCount >= MAX_ISSUE_ENTRIES) {
        incrementCapCounter();
        return;
    }
    sentIssueEntryCount += 1;
    logExtensionEvent(ISSUE_EVENT_NAME, {
        profile_id: issue.profileId,
        renderer_version: issue.rendererVersion,
        reason: issue.reason,
        line_type: lineType,
        event_type: eventType,
        count: issue.count,
    });
}
